import styled from 'styled-components'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { StaticRetailerStoreGrid } from '@/features/shop/components/StaticRetailerStoreGrid'
import { useCurrentUniversalCategory } from '@/features/shop/services/UniversalCategories/hooks'
import { Display } from '@shipt/design-system-typography'

export const RetailerSection = () => {
  const category = useCurrentUniversalCategory()
  const HeadingText = `Get same-day ${
    category?.name.toLowerCase() ?? ''
  } delivery and more from stores you know and love.`
  return (
    <GridLayoutContainer contentMaxWidth>
      <Heading as="h2" size="sm" align="center">
        {HeadingText}
      </Heading>
      <StaticRetailerStoreGrid />
    </GridLayoutContainer>
  )
}

const Heading = styled(Display)`
  margin: 0 auto;
  max-width: 900px;
  text-wrap: balance;
`
